import React from 'react';
import { Quote } from 'lucide-react';
export const PullQuote: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  return <blockquote className="relative my-14 pl-6 sm:pl-10 border-l-4 border-amber py-2 pr-4" data-id="element-181">
      <Quote className="absolute -top-4 -left-3 w-8 h-8 text-amber/20 rotate-180" data-id="element-182" />
      <p className="text-xl sm:text-2xl font-serif italic text-navy leading-relaxed" data-id="element-183">
        {children}
      </p>
    </blockquote>;
};